/** Split `items` into consecutive slices of at most `size` (e.g. to keep `.in()` URLs short). */
export function chunk<T>(items: readonly T[], size: number): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size));
  return out;
}
